import React from "react";

const MyFavDownArrow = (props) => {
  const {
    height = "16",
    width = "16",
    color = "#EEE",
    rotate = false,
    strokeWidth = "2",
    className,
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={`${className} ${rotate ? "rotate-180" : ""}`}
      width={width}
      height={height}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m19.5 8.25-7.5 7.5-7.5-7.5"
      />
    </svg>
  );
};

export default MyFavDownArrow;
